import React, { useState, useEffect, useContext, useRef } from 'react';
import ApiRequest from '../../Common/hooks/ApiRequest';
import { useNavigate } from 'react-router-dom';
import DateList from '../Views/DateList';
import ReservationV2 from '../Views/ReservationV2';
import { useReservation } from '../../Common/Context/ReserveContextV2';
import { SalesRootContext } from '../../Common/Context/SalesRootContext';
import { useAlert } from '../../Common/Context/AlertContext';
import RankingList from '../Views/RankingList';
import LatestList from '../Views/LatestList';

const CalendarTlap = () => {
    const { response, error, isLoading, fetchData } = ApiRequest();
    const navigate = useNavigate();
    const { salesRootData, setSalesRootData } = useContext(SalesRootContext);
    const { selectedRoot, TLAP_id, TLAP_name, company, tempReserveInfo } = salesRootData;
    const [selectedDateTime, setSelectedDateTime] = useState(tempReserveInfo?.temp_appoint_date || '');
    const [tempSelectedDate, setTempSelectedDate] = useState(tempReserveInfo?.temp_appoint_date || '');
    const { isReserved, setIsReserved } = useReservation();
    const { showAlert } = useAlert();
    const [isBoxOpen, setIsBoxOpen] = useState(false);

    const activityTimeout = useRef(null);
    const intervalRef = useRef(null);

    const resetSelectedDate = () => {
        setSelectedDateTime('');
        setTempSelectedDate('');
    };

    const resetActivityTimeout = () => {
        if (activityTimeout.current) {
            clearTimeout(activityTimeout.current);
        }
        activityTimeout.current = setTimeout(() => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        }, 7200 * 1000);
    };

    const handleActivity = () => {
        resetActivityTimeout();
        if (!intervalRef.current) {
            intervalRef.current = setInterval(calendarInterval, 2000);
        }
    };

    const calendarInterval = () => {
        const url = 'https://852t0urirb.execute-api.ap-northeast-1.amazonaws.com/beta/tlap/calendar/display';
        const data = { company, sales_root: selectedRoot };
        fetchData(url, data);
    };

    useEffect(() => {
        calendarInterval();
        intervalRef.current = setInterval(calendarInterval, 2000);

        window.addEventListener('mousemove', handleActivity);
        window.addEventListener('keydown', handleActivity);
        window.addEventListener('scroll', handleActivity);
        window.addEventListener('click', handleActivity);

        resetActivityTimeout();

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            if (activityTimeout.current) {
                clearTimeout(activityTimeout.current);
            }
            window.removeEventListener('mousemove', handleActivity);
            window.removeEventListener('keydown', handleActivity);
            window.removeEventListener('scroll', handleActivity);
            window.removeEventListener('click', handleActivity);
        };
    }, [selectedRoot, company]);

    const handleDateSelect = (dateTime) => {
        if (isReserved) {
            showAlert('他の日付を選択する前に、現在の予約を取り消してください。');
            return;
        }
        setSelectedDateTime(dateTime);
        setTempSelectedDate(dateTime);
    };

    const ReserveSuccess = (reserved) => {
        setIsReserved(reserved);
        if (!reserved) {
            resetSelectedDate();
        }
    };

    const goBackToSalesRoots = () => {
        if (!isReserved || showAlert('予約が完了していません。')) {
            navigate('/SalesRoots');
        }
    };

    useEffect(() => {
        if (response) {
            // console.log('APIレスポンス:', response);
        }
        if (error) {
            console.error('APIエラー:', error);
        }
    }, [response, error]);

    if (error) return <div>Error: {error}</div>;

    return (
        <div className='wrapper calenderTlap'>
            <button className='backBtn buttonStyle' onClick={goBackToSalesRoots}>戻る</button>
            <h2 className='calenderRoot'>{selectedRoot}</h2>
            {response && (
                <DateList
                    date_list={response.date_list}
                    time_list={response.time_list}
                    onDateSelect={handleDateSelect}
                    isReserved={isReserved}
                    resetSelectedDate={resetSelectedDate}
                    tempSelectedDate={tempSelectedDate}
                />
            )}
            {response && (
                <ReservationV2
                    selectedDateTime={selectedDateTime}
                    onSuccess={ReserveSuccess}
                    resetSelectedDate={resetSelectedDate}
                />
            )}
          <section className='ranking_wrapper'>
          <div className={`fixed_position ${isBoxOpen ? 'open' : 'closed'}`}>
    <button 
        onClick={() => setIsBoxOpen(!isBoxOpen)} 
        className={`toggle_button ${isBoxOpen ? 'open' : 'closed'}`}
    >
        {isBoxOpen ? '×' : 'ランキング'}
    </button>

            
                {isBoxOpen && response && (
                    <div className="flexB">
                        {response.ranking_list && (
                            <RankingList rankingList={response.ranking_list} />
                        )}
                        {response.latest_list && (
                            <LatestList latestList={response.latest_list} />
                        )}
                    </div>
                )}
            </div>
            </section>
        </div>
    );
};

export default CalendarTlap;
  